import Grid from '@mui/material/Grid';
import { Item } from '@openx/components-targeting/Targeting/shared/SelectedItems/Item';
import type { FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types';

type LocationSegmentsListItemProps = {
  item: FormSegment;
  isLastItem: boolean;
  onItemDelete: ((segment: FormSegment) => void) | undefined;
  dataTest?: string;
};

export const LocationSegmentsListItem = ({
  item,
  isLastItem,
  onItemDelete,
  dataTest,
}: LocationSegmentsListItemProps) => {
  const { name } = item;

  return (
    <Grid>
      <Item testId={`${dataTest}-item`} readonly={false} item={item} onRemove={onItemDelete}>
        {name}
        {!isLastItem && ','}
      </Item>
    </Grid>
  );
};
